import HeroSection from "@/sections/HeroSection";
import Marquee from "@/components/Marquee";
import EcosystemManifesto from "@/sections/EcosystemManifesto";
import AuthorityFramework from "@/sections/AuthorityFramework";
import BeaconMethod from "@/sections/BeaconMethod";
import CapabilitiesShowcase from "@/sections/CapabilitiesShowcase";
import WhereAuthority from "@/sections/WhereAuthority";
import Experience from "@/sections/Experience";
import PerspectivesTeaser from "@/sections/PerspectivesTeaser";
import FinalCTA from "@/sections/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <Marquee />
      <EcosystemManifesto />
      <AuthorityFramework />
      <BeaconMethod />
      <CapabilitiesShowcase />
      <WhereAuthority />
      <Experience />
      <PerspectivesTeaser />
      <FinalCTA />
    </div>
  );
}
